import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ApplicationInfo, ServiceVersionsState } from './environment.state';

export const environmentActions = createActionGroup({
  source: 'Environment',
  events: {
    /** Trigger loading of environment info from the API */
    'Load Environment Info': emptyProps(),
    /** Environment info loaded successfully */
    'Load Environment Info Success': props<{ info: ApplicationInfo }>(),
    /** Environment info loading failed */
    'Load Environment Info Error': props<{ error: string }>(),
    /** Dismiss the environment warning banner for this session */
    'Dismiss Banner': emptyProps(),
    /** Show the environment warning banner (restore after dismissal) */
    'Show Banner': emptyProps(),
    /** Load service versions from health endpoints */
    'Load Service Versions': emptyProps(),
    /** Service versions loaded successfully */
    'Load Service Versions Success': props<{ serviceVersions: ServiceVersionsState }>(),
    /** Service versions loading failed */
    'Load Service Versions Error': props<{ error: string }>(),
  },
});
